import React, { useRef, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import CarouselHeader from './CarouselHeader';
import Slider from 'react-slick';
import { dashboardCardDimensions, spaces } from '../../../assets/styles/themes/tokens';
import useScreenSize from '../../../utils/useScreenSize';
interface NewCarouselProps {
  title: string;
  onShowAll?: () => void;
  cardWidth?: number;
}

const NewCarousel: React.FC<NewCarouselProps> = (props) => {
  const { title, onShowAll, children, cardWidth = dashboardCardDimensions.width } = props;
  const { isXsScreen } = useScreenSize();
  const containerRef = useRef<HTMLDivElement>(null);
  const sliderRef = useRef<Slider>(null);

  const [slidesToShow, setSlidesToShow] = useState(1.1);
  const cardGap = isXsScreen ? parseInt(spaces.xs, 10) : parseInt(spaces.md, 10);

  const calculateSlidesToShow = () => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      const totalCardWidth = cardWidth + cardGap;
      const visibleCards = containerWidth / totalCardWidth;
      const slides = Math.ceil(visibleCards * 100) / 100;
      setSlidesToShow(slides);
    }
  };

  useEffect(() => {
    calculateSlidesToShow();

    const handleResize = () => {
      calculateSlidesToShow();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [cardWidth, cardGap]);

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: Math.floor(slidesToShow), 
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ paddingRight: spaces.md }}>
        <CarouselHeader 
          title={title}
          onSlideNext={() => sliderRef.current?.slickNext()}
          onSlidePrev={() => sliderRef.current?.slickPrev()}
          onShowAll={onShowAll} 
        />
      </Box>
      <Box
        ref={containerRef}
        data-testid='carousel' 
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          overflow: 'hidden',
          // slick centers a track narrower than the list via auto side-margins;
          // dashboard rows must stay left-aligned when they have few cards.
          '& .slick-track': { marginLeft: 0, marginRight: 0 },
        }}
      >
        <Slider 
          ref={sliderRef} 
          {...settings}
        >
          {children}
        </Slider>
      </Box>
    </Box>
  );
};

export default NewCarousel;
